import { Amplify } from 'aws-amplify';
import { amplifyConfig } from '../../amplify-config';

export const amplifyConfigure = () => {
  Amplify.configure(amplifyConfig, { ssr: true });
};
